fragment QuestionsAnswersFragment on questionsAnswers_Entry {
  typeHandle
  heading
  questions {
    ... on questionsBlock_Entry {
      heading
      body
    }
  }
  textOverlay
  cta {
    ...LinkFragment
  }
  image {
    url
    title
  }
  alt
}
